import { EVENT_CALENDAR_BLOCK_TYPE } from '@fox/blocks/contracts/block-types';
import { IBlockDefinition } from '@fox/blocks/contracts/block';
import { ButtonBlock } from '../button-block/button-block';
import { ButtonBlockProps } from '../button-block/contracts';

export const CalendarBlockRuntime: IBlockDefinition<ButtonBlockProps> = {
	type: EVENT_CALENDAR_BLOCK_TYPE,
	Component: ButtonBlock
};
